import { useEffect, useState } from 'react'
import { IonAccordion, IonAccordionGroup, IonAvatar, IonButton, IonContent, IonIcon, IonItem, IonItemDivider, IonLabel, IonList, IonRadio, IonRadioGroup, IonRow, IonSearchbar, IonSegment, IonSegmentButton, IonToolbar } from '@ionic/react'
import { useSelector } from 'react-redux';
import { RootState } from '../../redux/reducers';
import { caretDown } from 'ionicons/icons';
import { SafetyPadding } from '../../components/SafetyPadding';
import Api from '../../services/Api';

interface ComponentProps {
  handleInvite: Function,
  handleMultipleInvite: Function,
  invited_persons: Array<any>
  slideNext: Function
  cancelCreate: Function
}

export const getUnique = ((arr: any, index: any) => {
  const unique = arr
    .map((e: any) => e[index])
    // store the keys of the unique objects
    .map((e: any, i: any, final: any) => final.indexOf(e) === i && i)
    // eliminate the dead keys & store unique objects
  .filter((e: any) => arr[e]).map((e: any)=> arr[e]);      
  return unique;
})

const CreatePersonInvite = ({ handleInvite, handleMultipleInvite, invited_persons ,slideNext, cancelCreate} : ComponentProps) => {
  const api = Api.getInstance()
  const team = useSelector((state: RootState) => state.logIn.user.teams)
  const friends = useSelector((state: RootState) => state.friends)
  const [allAvailable, setAllAvailable] = useState<Array<any>>([])
  const [segment, setSegment] = useState<string | undefined>('all')
  const allTeamMembers: Array<any> = team.flatMap((team: any) => team.teamMembers)
  const allFriends: Array<any> = friends.friends
  const [person, setPerson] = useState<number | null>(0)
  let [results, setResults] = useState([...allAvailable]);

  useEffect(() => {
    // console.log(invited_persons, person)
    if(invited_persons.length === 0 && person !== 0) {
      handleInvite(person)
    }
  }, [invited_persons])

  const handleChange = (ev: Event) => {
    let query = "";
    const target = ev.target as HTMLIonSearchbarElement;
    if (target) query = target.value!.toLowerCase();

    setResults(allAvailable.filter(d => d.name.toLowerCase().indexOf(query) > -1));
  }

  useEffect(() => {
    if(invited_persons.length > 0) {
      setPerson(invited_persons[0])
    }
  }, [invited_persons])

  useEffect(() => {
    if(person !== 0) {
      handleInvite(person)
    } else if(person === 0) {
      handleInvite(null)
    } else {
    }
  }, [person])

  useEffect(() => {
    setAllAvailable(getUnique(allTeamMembers.concat(allFriends),'friendId'))
    setResults(getUnique(allTeamMembers.concat(allFriends),'friendId'))
  }, [])



  useEffect(() => {
    const renameArrayKey = () => {
      for(let i = 0; i < allAvailable.length; i++){
        if(!allAvailable[i].name) {
          allAvailable[i].name = allAvailable[i]['firstName'] + ' ' + allAvailable[i]['lastName'];
        }
        // delete allAvailable[i].firstName;
      }
    }
    renameArrayKey()
  }, [allAvailable])

  const onRadioChange = (e: any) => {
    setPerson(e.detail.value)
  }

  // const returnAll = () => {
  //   console.log('returnall')
  //  return 
  // }

  const returnNetworkOrFriends = () => {
    if(segment === 'network') {
      return <IonList>
      { team.map((team: any, index: any) => <IonAccordionGroup key={index}>
        <IonAccordion>
          <IonItemDivider slot="header" className="p-2" color="darkblue">
            <IonLabel>{team.teamName}</IonLabel>
            <IonIcon icon={caretDown} slot="end"/>
          </IonItemDivider>
          <IonRadioGroup 
            value={person}
            onIonChange={(e) => {
              onRadioChange(e)
            }}
            slot="content">
            { team.teamMembers.map((member: any, index: any) => <IonItem key={'teammemberlist'+index}>
              <IonAvatar slot="start">
                <img src={member.picture ? member.picture : '/assets/images/profile.png'} alt="team member avatar" />
              </IonAvatar>
              <IonLabel className="ml-2">{member.name}</IonLabel>
              <IonRadio slot="end" value={member.friendId}/>
            </IonItem>)}
          </IonRadioGroup>
        </IonAccordion>
      </IonAccordionGroup>) }
    </IonList>
    } else if(segment === 'friends'){
      return returnFriendslist()
    }
  }

  const returnFriendslist = () => {
    return <IonList>
      <IonRadioGroup value={person} onIonChange={(e) => {
        onRadioChange(e)
        }}>
        <IonItemDivider className="p-2" color="darkblue">
          {api.tr('upperselectionfarright')}
        </IonItemDivider>
        {friends.friends.map((friend: any, index: any) => {
          return <IonItem key={'teammemberlist'+index}>
          <IonAvatar slot="start">
            <img src={friend.picture ? friend.picture : '/assets/images/profile.png'} alt="team member avatar" />
          </IonAvatar>
          <IonLabel className="ml-2">{friend.firstName} {friend.lastName}</IonLabel>
          <IonRadio slot="end" value={friend.friendId}/>
        </IonItem>
        })}
      </IonRadioGroup>
    </IonList>
  }

  return (
    <IonContent>
      <IonToolbar class="flex justify-center p-2">
        <IonSegment 
          value={segment} 
          className="p-2 fullWidth" 
          onIonChange={(e) => {
            setSegment(e.detail.value)
          }}>
          <IonSegmentButton value="all">{api.tr('all')}</IonSegmentButton>
          <IonSegmentButton value="network">{api.tr('Network_Button')}</IonSegmentButton>
          <IonSegmentButton value="friends">{api.tr('upperselectionfarright')}</IonSegmentButton>
        </IonSegment>
      </IonToolbar>
      <IonRow className="flex justify-end p-2">
        <IonButton onClick={() => setPerson(0)}>{api.tr('clear_choice')}</IonButton>
      </IonRow>
      { segment === 'all' ? 
      <IonList>
        <IonToolbar className="p-2">
          <IonSearchbar 
            debounce={1000} 
            onIonChange={(ev) => {
              handleChange(ev)
            }}></IonSearchbar>
        </IonToolbar>
        <IonRadioGroup
          value={person}
          onIonChange={(e) => {
            onRadioChange(e)}}>
              <IonItem>
                {api.tr('topunder_search')}
                <IonRadio slot="end" value={0}/>
              </IonItem>
        { results.map((result: any, index: any) => (
          <IonItem key={index}>
            <IonAvatar slot="start">
              <img src={result.picture ? result.picture : '/assets/images/profile.png'} alt="avatar of person in friendslist"/>
            </IonAvatar>
            <IonLabel className="ml-2">{ result.name }</IonLabel>
            <IonRadio slot="end" value={result.friendId}/></IonItem>
          ))}
        </IonRadioGroup>
      </IonList>
      : returnNetworkOrFriends() }
      <IonRow className="mt-6">
        <IonButton 
            onClick={() => slideNext()}
            expand="block" 
            className="m-2 fullWidth">
            {api.tr('ContinueNext_page')}
          </IonButton>
        </IonRow>
        <IonRow>
          <IonButton 
            onClick={() => {
              cancelCreate()
            }}
            expand="block" 
            fill="clear"
            className="m-2 fullWidth">
            {api.tr('cancel')}
          </IonButton>
        </IonRow>
      <SafetyPadding />
    </IonContent>
  )
}

export default CreatePersonInvite